const T = require('prop-types');
const { canViewGroup } = require('utils/groups');

const internals = {};

internals.groupWithId = (props, propName, componentName) => {

    const value = props[propName];

    if (value?.id || (props.classId && value?.sid)) {
        return null;
    }

    return new Error(`${componentName} is waiting for ${propName}`);
};

exports.hasClassChatDependencies = ({
    classId,
    currentUser,
    group,
    rolePermissions,
    rolesInteractions,
    users
}) => !!classId
    && !!currentUser
    && !!(group?.id || group?.sid)
    && !!rolePermissions
    && Array.isArray(rolesInteractions)
    && Array.isArray(users);

exports.canLoadClassChat = ({ classId, group, rolePermissions, userIsInClass }) => !!classId
    && canViewGroup({
        group,
        rolePermissions,
        userIsInGroup: userIsInClass
    });

exports.dependencyPropTypes = {
    classId: T.number.isRequired,
    currentUser: T.object.isRequired,
    group: internals.groupWithId,
    rolePermissions: T.object.isRequired,
    rolesInteractions: T.array.isRequired,
    users: T.array.isRequired
};

if (process.env.NODE_ENV === 'test') {
    exports._internals = internals;
}
